import ReactGA from 'react-ga4';
import { v4 as uuidv4 } from "uuid";

const Analytics = (() => {
   let instance;
   const trackingId = GOOGLE_TRACKING_ID ? GOOGLE_TRACKING_ID : "G-B89ZL83RBW"; // Fallback to development tracking id

   const createInstance = () => {
      let idToken = uuidv4();
      ReactGA.initialize(trackingId, { testMode: process.env.NODE_ENV === 'test' });
      ReactGA.set({
         userId: idToken
      });

      return ReactGA;
   }

   return {
      getInstance: () => {
         if (!instance) {
            instance = createInstance();
            return instance;
         }
         return instance;
      }
   }
})();

export default Analytics;
